<!-- ─── report-viewer.component.html ─────────────────────────────────────── -->

<div class="report-shell" *ngIf="data; else loading">

  <!-- Toolbar -->
  <div class="toolbar no-print">
    <span class="toolbar-title">Statement Of Account</span>

    <div class="toolbar-actions">
      <button class="btn btn-print" (click)="print()">🖨 Print</button>
      <button class="btn btn-pdf" (click)="downloadPdf()">⬇ Download PDF</button>
    </div>
  </div>

  <!-- Pages -->
  <div class="pages-wrapper" id="report-pages">

    <div class="page" *ngFor="let page of pages; let i = index">

      <!-- ================= HEADER ================= -->
      <div class="page-header">

        <!-- LEFT -->
        <div class="header-left">
          <div><strong>CashBook:</strong> Petty Cash</div>
          <div><strong>From Date:</strong> {{ data.transactions[0]?.transactionDate | date:'dd/MM/yyyy' }}</div>
          <div><strong>To Date:</strong> {{ data.transactions[data.transactions.length-1]?.transactionDate | date:'dd/MM/yyyy' }}</div>
        </div>

        <!-- CENTER -->
        <div class="header-center">
          <h2>{{ companyName }}</h2>
          <h3> Statement Of Account</h3>
        </div>

        <!-- RIGHT -->
        <div class="header-right">
          <img 
               [src]="companyLogo | imageUrl"
               class="company-logo" />

        </div>

      </div>

      <!-- Opening Balance -->
      <div class="opening-balance-row" *ngIf="i === 0">
        <strong>Opening Balance:</strong>
        <span [class.negative]="data.transactions[0]?.openingBalance < 0">
          {{ data.transactions[0]?.openingBalance | number:'1.2-2' }}
        </span>
      </div>

      <!-- ================= TABLE ================= -->
      <table class="report-table">

        <thead>
          <tr>
            <th>Date</th>
            <th>Transaction Type</th>
            <th>Transaction No</th>
            <th>Party Name</th>
            <th>Description</th>
            <th>Status</th>
            <th class="num">Dr</th>
            <th class="num">Cr</th>
            <th class="num">Balance</th>
          </tr>
        </thead>

        <tbody>
          <tr *ngFor="let tx of page">

            <td>{{ tx.transactionDate | date:'dd/MM/yyyy' }}</td>
            <td>{{ tx.transactionTypeNameEn }}</td>
            <td>{{ tx.transactionNo }}</td>
            <td>{{ tx.partyName }}</td>
            <td>{{ tx.descriptionEn }}</td>
            <td  [style.color]="!tx.isPosted ? 'red' : null"> {{ tx.isPosted==true?'Posted':'UnPosted'}}</td>

            <td class="num">
              {{ tx.dr ? (tx.dr | number:'1.2-2') : '' }}
            </td>

            <td class="num">
              {{ tx.cr ? (tx.cr | number:'1.2-2') : '' }}
            </td>

            <td class="num" [class.negative]="tx.balance < 0">
              {{ tx.balance | number:'1.2-2' }}
            </td>

          </tr>
        </tbody>

        <!-- Totals -->
        <tfoot *ngIf="i === pages.length - 1">
          <tr class="totals">
            <td colspan="5"></td>
            <td ></td>
            <td class="num">{{ totalDr | number:'1.2-2' }}</td>
            <td class="num">{{ totalCr | number:'1.2-2' }}</td>
            <td class="num" [class.negative]="finalBalance < 0">
              {{ finalBalance | number:'1.2-2' }}
            </td>
          </tr>
        </tfoot>

      </table>

      <!-- ================= FOOTER ================= -->
      <div class="page-footer">
        <span>{{ today }}</span>
        <span>{{ i + 1 }} of {{ pages.length }}</span>
      </div>

    </div>

  </div>

</div>

<!-- Loading -->
<ng-template #loading>
  <div class="loading-state">Loading report…</div>
</ng-template>
